// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { externalLinkOpen } from '../../actions/externallink';
import { submitLoginJwt as submitLoginJwtAction } from '../../actions/login';
import { setNickname as setNicknameAction } from '../../actions/user';
import { getAuthFormUrl } from '../../config/urls';
import useMergeProps from '../../hooks/useMergeProps';

import Login from './Login';
import selectLoginProps from './Login.selector';

type LoginContainerProps = {
  className?: string;
  onClose: () => void;
};

const LoginContainer = (ownProps: LoginContainerProps) => {
  const dispatch = useDispatch();

  const selectedProps = useSelector(selectLoginProps);

  const setUserNickName = useCallback(
    (nickname) => {
      dispatch(setNicknameAction(nickname));
    },
    [dispatch],
  );

  const submitLoginJwt = useCallback(
    (jwt, expirationDelay, licence) => {
      dispatch(submitLoginJwtAction(jwt, expirationDelay, licence));
    },
    [dispatch],
  );

  const openExternalLink = useCallback(
    (url, options) => {
      dispatch(externalLinkOpen(url, options));
    },
    [dispatch],
  );

  const otherProps = useMemo(
    () => ({
      authFormUrl: getAuthFormUrl(),
      setUserNickName,
      submitLoginJwt,
      openExternalLink,
    }),
    [openExternalLink, setUserNickName, submitLoginJwt],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <Login {...enhancedProps} />;
};

export default LoginContainer;
